/** MultipleAttackPenalty (Foundry: rule-element/multiple-attack-penalty.ts): a smaller Multiple Attack Penalty for a selector's strikes. */
import { localize } from "../labels";
import { cleanRuleValue, resolveInjectedProperties, resolveValue } from "../resolve";
import type { EngineState } from "../state";
import type { RuleHandler, RuleInstance } from "./base";

interface MAPData {
  selector: string;
  value: unknown;
}

function parse(rule: RuleInstance): void {
  const s = rule.source;
  if (typeof s.selector !== "string" || !s.selector) return rule.fail("selector: must be a non-empty string");
  const value = cleanRuleValue(s.value);
  if (value === undefined) return rule.fail("value: may not be undefined");
  rule.data = { selector: s.selector, value } satisfies MAPData as unknown as Record<string, unknown>;
}

function beforePrepareData(rule: RuleInstance, state: EngineState): void {
  if (rule.ignored) return;
  const data = rule.data as unknown as MAPData;
  const selector = resolveInjectedProperties(rule, state, data.selector);
  if (rule.ignored || selector.length === 0) return;
  const value = Number(resolveValue(rule, state, data.value)) || 0;
  if (value < 0) {
    const ruleLabel = state.catalogue?.localize(rule.label) ?? rule.label;
    const label = localize(state, "PF2E.UI.RuleElements.MultipleAttackPenalty.Breakdown", "{label} (Multiple Attack Penalty)", { label: ruleLabel });
    (state.synthetics.multipleAttackPenalties[selector] ??= []).push({ label, penalty: value, predicate: resolveInjectedProperties(rule, state, structuredClone(rule.predicate), { warn: false }), parentOptions: rule.item.getRollOptions("parent"), source: rule.item.uuid });
  } else if (value !== 0) {
    rule.fail("value: must resolve to less than or equal to zero");
  }
}

export const MultipleAttackPenaltyHandler: RuleHandler = { key: "MultipleAttackPenalty", parse, beforePrepareData };
